import styles from './styles';
import { translate } from 'react-i18next';
import {
  RECEPTION_BANK_CONTACT,
  RECEPTION_CARD,
  RECEPTION_CASH,
  RECEPTION_INVOICE,
  RECEPTION_DEBT,
  RECEPTION_WORK_ACCIDENT,
  RECEPTION_HOSPITAL_ADMISSION
} from 'services/constants';

//──── images ────────────────────────────────────────────────────────────────────────────
import BanContact from 'assets/images/invoice/bancontactIcon.svg';
import Card from 'assets/images/invoice/cardIcon.svg';
import Cash from 'assets/images/invoice/cash.svg';
import Invoice from 'assets/images/invoice/invoiceIcon.svg';
import Debt from 'assets/images/invoice/debtIcon.svg';
import Work from 'assets/images/invoice/workIcon.svg';
import BanContactActive from 'assets/images/invoice/bancontactIcon-active.svg';
import CardActive from 'assets/images/invoice/cardIcon-active.svg';
import CashActive from 'assets/images/invoice/cash-active.svg';
import InvoiceActive from 'assets/images/invoice/invoiceIcon-active.svg';
import DebtActive from 'assets/images/invoice/debtIcon-active.svg';
import WorkActive from 'assets/images/invoice/workIcon-active.svg';
import MedicalKit from 'assets/images/invoice/medical-kit.svg';
import MedicalKitActive from 'assets/images/invoice/medical-kit-active.svg';

const paymentMethodsList = [
  {
    type: RECEPTION_BANK_CONTACT,
    translateLabel: ['value_bancontact'],
    icon: BanContact,
    activeIcon: BanContactActive
  },
  {
    type: RECEPTION_CARD,
    translateLabel: ['value_visa', 'value_mastercard'],
    icon: Card,
    activeIcon: CardActive
  },
  {
    type: RECEPTION_CASH,
    translateLabel: ['value_cash'],
    icon: Cash,
    activeIcon: CashActive
  },
  {
    type: RECEPTION_INVOICE,
    translateLabel: ['value_invoice'],
    icon: Invoice,
    activeIcon: InvoiceActive
  },
  {
    type: RECEPTION_DEBT,
    translateLabel: ['value_ocmw', 'value_debt_mediation'],
    icon: Debt,
    activeIcon: DebtActive,
    nowrap: true
  },
  {
    type: RECEPTION_WORK_ACCIDENT,
    translateLabel: ['value_work_accident'],
    icon: Work,
    activeIcon: WorkActive
  },
  {
    type: RECEPTION_HOSPITAL_ADMISSION,
    translateLabel: ['value_hospital_admission'],
    icon: MedicalKit,
    activeIcon: MedicalKitActive
  }
];

const PaymentSelection = props => {
  const { errorLabel, paymentMethod, onClick, i18n } = props;
  const isActive = item => paymentMethod === item.type && !errorLabel;

  return (
    <styles.PaymentBlock errorLabel={errorLabel} disabled={errorLabel}>
      {paymentMethodsList.map((item, index) => (
        <styles.Rectangle
          key={`${item.type}-${index}`}
          paymentMethod={paymentMethod}
          isActive={isActive(item)}
          onClick={() => onClick(item.type)}
        >
          <styles.IconWrapper>
            <styles.Icon src={isActive(item) ? item.activeIcon : item.icon} />
          </styles.IconWrapper>

          <styles.InscriptionSection nowrap={item.nowrap}>
            {item.translateLabel &&
            typeof item.translateLabel === 'object' &&
            item.translateLabel.length
              ? item.translateLabel.map(keyLabel => <p key={keyLabel}>{i18n.t(keyLabel)}</p>)
              : null}
          </styles.InscriptionSection>
        </styles.Rectangle>
      ))}
    </styles.PaymentBlock>
  );
};

export default translate()(PaymentSelection);
